.botao {
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid color-mix(in srgb, var(--stroke) 92%, transparent);
  border-radius: 11px;
  background: color-mix(in srgb, var(--card) 90%, rgba(255, 255, 255, 0.04));
  color: color-mix(in srgb, var(--muted) 86%, #ffffff 14%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 0 0 auto;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease;
}

.botao:hover {
  background: color-mix(in srgb, var(--hover) 82%, rgba(255, 255, 255, 0.03));
  border-color: color-mix(in srgb, var(--accent-main) 20%, var(--stroke));
  color: var(--text);
}

.botao:focus-visible {
  outline: none;
  border-color: color-mix(in srgb, var(--accent-main) 36%, var(--stroke));
}

.botao:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.icone {
  width: 15px;
  height: 15px;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
